import React from 'react';
import './section4.css'
import Title from '../common/title';
import Btn from '../common/btn';
import img2 from '../../asserts/img2.png'
import img3 from '../../asserts/img3.png'
import star1 from '../../asserts/star.png'

const Sec4 = () => {
    return (<>
    <section className='sec4'>
<img className='sec4-img' src={img2} alt="" />
        <article className='sec4-div'>
 <Title title='BOOK YOUR UNIT NOW !' t='title2' />
<Btn btn='Book Now' />
<img className='star' src={star1} alt="" />

</article>
<img className='sec4-img' src={img3} alt="" />

    </section>
    </>  );
}
 
export default Sec4;